// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"languagesButton_wrapper__3OVW5","list":"languagesButton_list__2rRxX","item":"languagesButton_item__sOjPa","active":"languagesButton_active__3Q6sK"};